import { m } from 'framer-motion';
import { IconBrandGithub, IconBrandLinkedin, IconMail } from "@tabler/icons-react";
import { Typewriter } from './Typewriter';
import { Asterism } from './Ornaments';

const links = [
  { href: 'https://github.com/francocirulli95', label: 'GitHub', icon: IconBrandGithub },
  { href: 'https://www.linkedin.com/in/franco-cirulli-9b9240bb/', label: 'LinkedIn', icon: IconBrandLinkedin },
  { href: 'mailto:francocirulli95@gmail.com', label: 'Email', icon: IconMail },
];

export function Footer({ isDark = true }) {
  return (
    <m.footer
      className="pt-14 pb-12 sm:pt-20 sm:pb-16"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      {/* The old full-bleed rule is replaced by an asterism — the printer's
          mark for "a break in the text". It needs equal air above and below
          (the footer's pt matches this mb) or it stops reading as a break and
          just attaches to whichever block is closer. */}
      <m.div
        className={`mx-auto mb-14 w-fit sm:mb-20 ${isDark ? 'text-neutral-700' : 'text-neutral-300'}`}
        initial={{ opacity: 0, scale: 0.7 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: [0.22, 0.61, 0.36, 1] }}
        viewport={{ once: true }}
      >
        <Asterism className="h-3 w-4" />
      </m.div>

      <div className="flex flex-col items-center justify-between gap-7 md:flex-row md:gap-4">
        <m.div
          className={`u-label flex items-center text-[11px] tracking-[0.18em] transition-colors ${
            isDark ? 'text-neutral-600' : 'text-neutral-500'
          }`}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
          viewport={{ once: true }}
        >
          <span>Turning 🧉 into&nbsp;</span>
          <Typewriter
            text={["code", "projects", "prompts", { text: "bugs... wait...", waitTime: 0 }]}
            speed={80}
            deleteSpeed={40}
            waitTime={2500}
            cursorClassName={isDark ? 'text-neutral-700' : 'text-neutral-300'}
          />
        </m.div>

        <ul
          className={`flex flex-wrap gap-6 transition-colors ${
            isDark ? 'text-neutral-600' : 'text-neutral-400'
          }`}
        >
          {links.map(({ href, label, icon: Icon }, index) => (
            <m.li
              key={label}
              initial={{ opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.08 }}
              viewport={{ once: true }}
            >
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className={`block transition-colors duration-200 ${
                  isDark ? 'hover:text-neutral-200' : 'hover:text-neutral-900'
                }`}
              >
                <Icon className="h-[18px] w-[18px]" strokeWidth={1.5} />
              </a>
            </m.li>
          ))}
        </ul>
      </div>
    </m.footer>
  );
}
